import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyInfoCircleIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 15 16",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M7.5 15.496c4.103 0 7.5-3.404 7.5-7.5 0-4.103-3.404-7.5-7.507-7.5C3.397.496 0 3.893 0 7.996c0 4.096 3.404 7.5 7.5 7.5Zm0-1.25a6.22 6.22 0 0 1-6.243-6.25c0-3.47 2.765-6.25 6.236-6.25 3.47 0 6.257 2.78 6.257 6.25s-2.78 6.25-6.25 6.25Zm-1.287-2.132h2.993a.518.518 0 1 0 0-1.037h-.912V7.334c0-.397-.198-.661-.573-.661H6.338a.518.518 0 1 0 0 1.037h.787v3.367h-.912a.518.518 0 1 0 0 1.037Zm1.22-6.662a.951.951 0 0 0 .957-.963.956.956 0 1 0-1.912 0c0 .537.426.963.956.963Z"
  })
});
export default EmptyInfoCircleIcon;